import React from 'react';
import Icon from '@ant-design/icons';
import classnames from "classnames";
import styles from "./ActiveIcon.module.scss";
export default function ActiveIcon(props) {
    const { component, action, disabled, additionalStyles, alert } = props;
    return (React.createElement("div", { className: classnames(styles.wrapper, additionalStyles, { [styles.alert]: alert && !disabled, [styles.disabled]: disabled }), onClick: !disabled ? action : () => { } },
        React.createElement(Icon, { component: component })));
}
